import "jquery"
import 'bootstrap'
import "perfect-scrollbar"
import "typedjs"
import "countup"
import "rellax"
import "tilt"
import "parallax"
import "anime"

// import "waypoint"
import { CookieConsent } from '../cconsent';

// Currently not used. This is in pure js. You find the js files from here in ../js
class Main {

	constructor() {
	  let consent = new CookieConsent();
	}

}

new Main();

